import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useHistory, Switch, Route, Redirect } from 'react-router-dom';
import ConnectedCampaign from './Campaign/ConnectedCampaign';
import ConnectedAdvertisers from './Advertisers/ConnectedAdvertisers';
import ConnectedAdBuilder from './AdBuilder/ConnectedAdBulder';
import ConnectedAnalytics from './Analytics/ConnectedAnalytics';
import { useAdvertisers } from '../../Contexts/AdvertisersContext';
import { useProfile } from '../../Contexts/UserProfileContext';
import ConnectedLeads from './Leads/ConnectedLeads';
import ConnectedAgency from './Agency/ConnectedAgency';
import ConnectedSettings from './Settings/ConnectedSettings';
import ConnectedTeach from './Teach/ConnectedTeach';
import ConnectedDashboard from './ConnectedDashboard';
import ConnectedAdServices from './AdServices/ConnectedAdServices';
import StyledChatBot from './ChatBot/StyledChatBot';
import ChatWithMeImg from '../../Assets/chat-with-me.png';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    justify-content: center;
`;
const PortalGutters = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;
`;

const MobileTabs = styled.div`
    background-color: #2e69fe;
    height: 75px;
    width: 75px;
    position: absolute;
    right: 0px;
    color: #fafbf7;
    display: flex;
    text-align: center;
    align-items: center;
    display: none;

    @media only screen and (max-width: 620px) {
        display: unset;
    }
`;

const CollapsedBot = styled.img`
    object-fit: contain;
    width: 100px;
    height: 100px;
    cursor: pointer;

    :hover {
        @keyframes wiggle {
            0% {
                transform: rotate(-5deg);
            }
            50% {
                transform: rotate(5deg);
            }
            100% {
                transform: rotate(-5deg);
            }
        }

        animation: wiggle 1s infinite;
    }
`;
const Portal = () => {
    const { advertiserMetaData, currentAdvertiser } = useAdvertisers();
    const history = useHistory();
    const { profile } = useProfile();

    const [botIsOpen, setBotIsOpen] = useState(true);
    const firstTimeSignIn = localStorage.getItem('firstTimeSignIn');

    const role = {
        isAgency: profile.isAgency,
        isAdvertiser: profile.isIndividual,
        isSiteAdmin: profile.isSiteAdmin,
    };

    const { hasCompletedData } = { ...advertiserMetaData?.selectedAdvertiserTeachData };
    const isThePrimaryAdvertiser = currentAdvertiser?.isAgencyPrimary;

    useEffect(() => {
        if (role.isAgency && isThePrimaryAdvertiser && hasCompletedData === true) {
            localStorage.setItem('firstTimeSignIn', false);
        }
        if (
            (firstTimeSignIn === 'true' && role.isAgency && isThePrimaryAdvertiser && hasCompletedData === false) ||
            (firstTimeSignIn === 'true' && role.isAdvertiser && hasCompletedData === false)
        ) {
            history.push('/portal/teach/intro');
            localStorage.setItem('firstTimeSignIn', false);
        }
    }, [firstTimeSignIn, hasCompletedData, isThePrimaryAdvertiser, role]);

    return (
        <div>
            <div style={{ right: 20, bottom: 10, position: 'fixed', zIndex: '99' }}>
                {botIsOpen ? (
                    <StyledChatBot setBotIsOpen={setBotIsOpen} botIsOpen={botIsOpen} />
                ) : (
                    <CollapsedBot onClick={() => setBotIsOpen(true)} src={ChatWithMeImg} alt="collapsed-bot" />
                )}
            </div>

            <Container>
                <PortalGutters>
                    <Switch>
                        <Route path="/portal/agency">
                            <ConnectedAgency />
                        </Route>
                        <Route path="/portal/advertiser">
                            <ConnectedAdvertisers />
                        </Route>
                        <Route path="/portal/campaign">
                            <ConnectedCampaign />
                        </Route>
                        <Route path="/portal/adBuilder">
                            <ConnectedAdBuilder />
                        </Route>
                        <Route path="/portal/analytics">
                            <ConnectedAnalytics />
                        </Route>
                        <Route path="/portal/leads">
                            <ConnectedLeads />
                        </Route>
                        <Route path="/portal/teach">
                            <ConnectedTeach />
                        </Route>
                        <Route path="/portal/adServices">
                            <ConnectedAdServices />
                        </Route>
                        <Route path="/portal/settings">
                            <ConnectedSettings />
                        </Route>
                        <Route path="/portal/dashboard">
                            <ConnectedDashboard />
                        </Route>
                        <Redirect to={'/portal/dashboard'} />
                    </Switch>
                </PortalGutters>
            </Container>
        </div>
    );
};

export default Portal;
